export default __webpack_public_path__ + "static/media/Exterior (3).4832655b.jpg";